<template>
  <CustomPage :noTitle="true" class="free-goods-container">
    <div slot="content" class="content">
      <CustomHead
        title="免费抢好货"
        :navBarToggle="true"
        scrollDOM=".free-goods-container .wrapper"
        navBarFixedBackgroundColor="#f07e3c"
        @sharePoster="sharePoster"
      />
      <component
        ref="Comp"
        :is="component"
        :myself="myself"
        :data="data"
        @queryFreeGoodsByTaskid="queryFreeGoodsByTaskid"
        @sharePoster="sharePoster" />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page'
import CustomHead from '@/components/custom-head'
import Home from './home'
import Detail from './detail'
import { queryFreeGoods, queryFreeGoodsByTaskid, sharePoster } from '@/api/freeGoods'
export default {
  components: { CustomPage, CustomHead, Home, Detail },
  data() {
    return {
      taskid: this.$route.query.taskid,
      myself: this.$route.query.nativeCustomerId === this.$store.state.user.customerId, // 是否是自己分享的链接
      component: null,
      data: {},
    }
  },
  watch: {
    $route(route) {
      this.getData()
    },
  },
  created() {
    if (this.taskid) {
      this.component = 'Detail'
      this.queryFreeGoodsByTaskid()
    } else {
      this.getData()
    }
  },
  methods: {
    getData() {
      const query = this.$route.query
      if (Number(query.flag) === 1) {
        this.component = 'Detail'
      } else {
        this.component = 'Home'
      }
      this.queryFreeGoods()
    },
    // 查询砍价商品
    queryFreeGoods() {
      this.$store.dispatch('app/showLoading')
      queryFreeGoods()
        .then((res) => {
          this.$store.dispatch('app/hideLoading')
          if (res.data) {
            this.data = this.converData(res.data)
            this.component = 'Detail'
          }
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    // // 帮他人砍价获取商品
    queryFreeGoodsByTaskid() {
      this.$store.dispatch('app/showLoading')
      queryFreeGoodsByTaskid({ taskId: this.taskid })
        .then((res) => {
          this.$store.dispatch('app/hideLoading')
          if (res.data) {
            this.data = this.converData(res.data)
            this.component = 'Detail'
          }
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    converData(data) {
      const cutPrice = data.inviteRecordList.reduce(
        (total, num) => total + num.cutPrice * 100,
        data.quota * 100
      )
      data.cutPriceAll = Math.round(cutPrice) / 100
      const percentage = Math.round((cutPrice / data.targetPrice) * 100) / 100
      data.percentage = percentage < 6 ? 6 : percentage
      data.surplusPrice = Math.round(data.targetPrice * 100 - cutPrice) / 100
      return data
    },
    sharePoster() {
      const taskId = this.taskId || this.data.taskId
      let forwardUrl = null
      const data = {
        title: '免费抢好货',
        desc: null,
        imgUrl: null
      }
      if (this.component === 'Detail') {
        forwardUrl = `${window.location.origin}/freeGoods?` +
                           `taskid=${taskId}&` +
                           `customerId=${this.$store.state.user.forwardId}&` + // 分销商id（本账号、或上级账号）
                           `nativeCustomerId=${this.$store.state.user.customerId}` // 本账号id
        data.desc = '快来帮好友砍一刀'
        data.imgUrl = this.data.imgUrl
      } else {
        forwardUrl = `${window.location.origin}/freeGoods?` +
                     `customerId=${this.$store.state.user.forwardId}`
        data.desc = '免费抢好货'
        data.imgUrl = this.$refs.Comp.data[0]?.goodsList[0]?.good?.goodsImg
      }

      this.$store.dispatch('app/showLoading')
      sharePoster({ urlAddress: forwardUrl }).then(res => {
        this.$store.dispatch('app/hideLoading')
        
        this.sharePosterOpen(res.data, forwardUrl, data)
      }).catch(() => {
        this.$store.dispatch('app/hideLoading')
      })
    },
    sharePosterOpen(url, forwardUrl, data) {
      console.log({
        url,
        title: data.title,
        desc: data.desc,
        link: forwardUrl,
        imgUrl: data.imgUrl
      });
      this.$store.dispatch('sharePoster/show', {
        url,
        title: data.title,
        desc: data.desc,
        link: forwardUrl,
        imgUrl: data.imgUrl
      })
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  .custom-head {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    /deep/ .van-nav-bar .van-nav-bar__title {
      font-size: 40px;
      line-height: 40px;
    }
  }
}
</style>